<script>
import { projectState } from "@app/store/projectStore.svelte.js";
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
import throttle from "just-throttle";
import Swal from "sweetalert2";
import { SWAL_BASE, SWAL_CLASSES } from "@app/lib/swalClasses.js";
import * as m from "@app/paraglide/messages.js";

let { event = $bindable({}) } = $props();

function getNotesStatus() {
    //Return the class for the button based on the status of the notes and reply. If there is a note and a reply we need to check if both are done.
    if (event.notes && event.reply) {
        return event.notesCheck && event.replyCheck
            ? "text-primary"
            : "text-warning";
    } else if (event.notes) {
        return event.notesCheck ? "text-primary" : "text-warning";
    } else if (event.reply) {
        return event.replyCheck ? "text-primary" : "text-warning";
    }
}

const saveToHistory = throttle(
    () => {
        insertHistoryAction({
            name: "update notes", //action name
            eventGroup: projectState.selected,
            snapshots: [
                {
                    store: "eventGroupState",
                    value: JSON.stringify(eventGroupState),
                },
            ],
        });
    },
    250,
    {
        leading: false,
        trailing: true,
    },
);

async function openNotesModal() {
    const { value: formValues } = await Swal.fire({
        ...SWAL_BASE,
        customClass: SWAL_CLASSES.confirmCancel,
        draggable: true,
        html: `
            <div class="text-start">
                <div class="mb-3">
                    <label for="swal-notes-input" class="form-label fw-bold">${m.event_notes_notes_label()}</label>
                    <textarea id="swal-notes-input" class="form-control bg-secondary text-dark" rows="4" placeholder="${m.event_notes_notes_placeholder()}">${event.notes || ''}</textarea>
                </div>
                <div class="form-check form-switch mb-3">
                    <input class="form-check-input" type="checkbox" id="swal-notes-complete" ${event.notesCheck ? 'checked' : ''}>
                    <label class="form-check-label" for="swal-notes-complete">${m.event_notes_notes_complete_label()}</label>
                </div>
                <hr>
                <div class="mb-3">
                    <label for="swal-reply-input" class="form-label fw-bold">${m.event_notes_reply_label()}</label>
                    <textarea id="swal-reply-input" class="form-control bg-secondary text-dark" rows="4" placeholder="${m.event_notes_reply_placeholder()}">${event.reply || ''}</textarea>
                </div>
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="swal-reply-complete" ${event.replyCheck ? 'checked' : ''}>
                    <label class="form-check-label" for="swal-reply-complete">${m.event_notes_reply_complete_label()}</label>
                </div>
            </div>
        `,
        showCancelButton: true,
        confirmButtonText: m.event_notes_save_button(),
        cancelButtonText: m.event_notes_cancel_button(),
        preConfirm: () => {
            const notes = document.getElementById('swal-notes-input').value;
            const notesComplete = document.getElementById('swal-notes-complete').checked;
            const reply = document.getElementById('swal-reply-input').value;
            const replyComplete = document.getElementById('swal-reply-complete').checked;
            return {
                notes,
                notesComplete,
                reply,
                replyComplete
            };
        }
    });

    if (formValues) {
        // Update the event with the new values
        event.notes = formValues.notes;
        event.notesCheck = formValues.notesComplete;
        event.reply = formValues.reply;
        event.replyCheck = formValues.replyComplete;
        
        // Save to history
        saveToHistory();
    }
}
</script>

<button
    aria-label={m.event_notes_toggle_aria_label()}
    type="button"
    class="btn btn-link text-custom-medium {event.notes || event.reply
        ? getNotesStatus()
        : 'text-dark'}"
    title={event.notes || event.reply ? m.event_notes_view_edit_title() : m.event_notes_add_title()}
    onclick={openNotesModal}>
    <i class="bi bi-chat-right-text"></i>
</button>

<style>
button {
    padding: 2px;
    margin: 0;
}
</style>
